import React, { useRef, useState, useEffect } from 'react'
import { motion, useIsPresent } from "framer-motion";

import Navbar from '../components/Navbar'
import SubKv from '../components/SubKv'
import Banner from '../components/Banner';
import SubHeader from '../components/SubHeader';
import Outro from '../components/Outro'
import { bannerLobby, bannerPrivateroom } from "../assets/data/bannerData"
import { loungeKvData, loungeData } from "../assets/data/subData";

import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/scss';
import 'swiper/scss/navigation';
import 'swiper/scss/pagination';


export function Lounge() {

  const isPresent = useIsPresent();
  const containerWrap = useRef();
  const lounge = useRef();
  const title = useRef([]);
  const desc = useRef([]);
  const loungeContainer = useRef([]);
  const tabList = useRef([]);
  const tabBtn = useRef([['', ''], ['', ''], ['', '']]);
  const tabContent = useRef([['', ''], ['', ''], ['', '']]);
  const swipers = useRef([['', ''], ['', ''], ['', '']]);

  let tabContents = [];
  let [tabHeight, setTabHeight] = useState((window.innerWidth / 100) * 30)
  let [tabidx, setTabidx] = useState([0, 0, 0]);
  let subHeaderEndY = 0;

  function moveScroll(placeIdx, idx) {
    tabContent.current[placeIdx][idx].scrollIntoView(
      { behavior: "smooth", block: "start", inline: "nearest" });
  }

  // 텍스트 & 이미지 등장 효과
  const observer = useRef(
    new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('on');
          } else {
            entry.target.classList.remove('on');
          }
        });
      }, { threshold: 0.1 }
    )
  );



  function getCurrentContents () {

    let currentY = containerWrap.current.scrollTop;
    subHeaderEndY = loungeContainer.current[2].getBoundingClientRect().y + loungeContainer.current[2].getBoundingClientRect().height + currentY;

    if (currentY < subHeaderEndY && currentY > window.innerHeight) {
      containerWrap.current.classList.add('white');
    } else {
      containerWrap.current.classList.remove('white');
    }

    for (let i = 0; i < tabContent.current.length; i++) {
      for (let j = 0; j < tabContent.current[i].length; j++) {

        let startY = tabContent.current[i][j].getBoundingClientRect().y + currentY - tabHeight;
        let endY = startY + tabContent.current[i][j].getBoundingClientRect().height;

        if (currentY > startY && currentY < endY) {
          let newTabidx = [...tabidx];
          newTabidx[i] = j;
          setTabidx(newTabidx);
        }
      }

    }
  }


  useEffect(() => {
    if (tabContent.current[0] && tabContent.current[1] && tabContent.current[2]) {
      tabContents = [...tabContent.current[0], ...tabContent.current[1], ...tabContent.current[2]];
    }
  }, [tabContent]);

  useEffect(() => {
    containerWrap.current?.addEventListener('scroll', getCurrentContents)

    return () => containerWrap.current?.removeEventListener('scroll', getCurrentContents)

  }, [tabHeight]);



  useEffect(() => {
    if (window.innerWidth < 768) {
      setTabHeight((window.innerWidth / 100) * 30);
    } else if (window.innerWidth < 1024) {
      setTabHeight((window.innerWidth / 100) * 25);
    } else if (window.innerWidth < 1921) {
      setTabHeight((window.innerWidth / 100) * 10);
    } else {
      setTabHeight(197);
    }
    

    for (let i = 0; i < title.current.length; i++) {
      observer.current.observe(title.current[i]);
      observer.current.observe(desc.current[i]);
      observer.current.observe(loungeContainer.current[i]);
    }

  }, [window.innerWidth]);

  return (
    <div className="container">
      <div className="container_wrap lounge-container" ref={containerWrap}>
        <Navbar />
        <SubHeader title={loungeKvData.title} class={loungeKvData.class} content={containerWrap.current} />
        <SubKv title={loungeKvData.title} img={loungeKvData.img} class={loungeKvData.class} />

        <section id="LOUNGE" ref={lounge} className="contents lounge">
          {
            loungeData.map((place, placeIdx) => (

              <article key={placeIdx} className="lounge__article">
                <div className="lounge__title__wrap">
                  <div className="lounge__title">
                    <div className="title" ref={el => { title.current[placeIdx] = el }}>
                      <picture>
                        <img src={place.main.img} alt={place.main.title} />
                      </picture>
                    </div>
                    <p className="desc" ref={el => { desc.current[placeIdx] = el }}>{place.main.desc}</p>
                  </div>
                </div>

                <div className="lounge__container" ref={el => { loungeContainer.current[placeIdx] = el }}>
                  <div className="lounge__inner">

                    <ul className="tab__list" role="tablist" ref={el => { tabList.current[placeIdx] = el }}>
                      {place.contents.map((content, idx) => (
                        <li
                          className={"tab__item " + (idx === tabidx[placeIdx] ? 'active' : '')}
                          onClick={() => {
                            // let newTabidx = [...tabidx];
                            // newTabidx[placeIdx] = idx;
                            // setTabidx(newTabidx);
                            moveScroll(placeIdx, idx);
                          }}
                          role="tab" key={idx}
                          ref={el => { tabBtn.current[placeIdx][idx] = el }}
                        >
                          <a>
                            <span className="en gowun-batang-regular">{content.title_en}</span>
                            <span className="kr">{content.title_kr}</span>
                          </a>
                        </li>
                      ))}
                    </ul>

                    <div className="tab__contents">
                      {place.contents.map((content, idx) => {
                        return (
                          <div className="tab__content" key={idx} id={content.title_en}
                            ref={el => {
                              tabContent.current[placeIdx][idx] = el
                            }}>
                            <Swiper
                              ref={el => {
                                swipers.current[placeIdx][idx] = el
                              }}
                              effect="slide"
                              loop
                              speed="750"
                              modules={[Navigation, Pagination, Autoplay]}
                              autoplay={{ delay: "3000", disableOnInteraction: false }}
                              navigation
                              pagination={{ clickable: true }}
                            >
                              {
                                content.img.map((img, key) => (
                                  <SwiperSlide role="tabpanel" key={key}>
                                    <picture className='tab-img'>
                                      <source media="(min-width: 1024px)" srcSet={img.pcSrc} />
                                      <source media="(min-width: 768px) and (max-width: 1023px)" srcSet={img.tabSrc} />
                                      <source media="(min-width: 0px) and (max-width: 767px)" srcSet={img.moSrc} />
                                      <img src={img.pcSrc} alt={img.alt} />
                                    </picture>
                                  </SwiperSlide>
                                ))
                              }
                            </Swiper>
                            <p className="tab__desc gowun-batang-regular">
                              <span className="sub_desc">{place.main.title}</span>
                              {content.desc}
                            </p>
                          </div>
                        )
                      })}
                    </div>

                  </div>
                </div>
              </article>
            ))
          }


          <Outro />

          <Banner
            classType={bannerLobby.classType}
            title={bannerLobby.title}
            titleSrcPc={bannerLobby.titleSrcPc}
            titleSrcTab={bannerLobby.titleSrcTab}
            titleSrcMo={bannerLobby.titleSrcMo}
            unionSrc={bannerLobby.unionSrc}
            description1={bannerLobby.description1}
            description2={bannerLobby.description2}
            linkDesc={bannerLobby.linkDesc}
            link={bannerLobby.link}
          />
          <Banner
            classType={bannerPrivateroom.classType}
            title={bannerPrivateroom.title}
            titleSrcPc={bannerPrivateroom.titleSrcPc}
            titleSrcTab={bannerPrivateroom.titleSrcTab}
            titleSrcMo={bannerPrivateroom.titleSrcMo}
            unionSrc={bannerPrivateroom.unionSrc}
            description1={bannerPrivateroom.description1}
            description2={bannerPrivateroom.description2}
            linkDesc={bannerPrivateroom.linkDesc}
            link={bannerPrivateroom.link}
          />

          {/* (s) 페이지 전환 애니메이션 */}
          <motion.div
            initial={{ scaleY: 1 }}
            animate={{ scaleY: 0, transition: { duration: 0.5, ease: "circOut" } }}
            exit={{ scaleY: 1, transition: { duration: 0.5, ease: "circIn" } }}
            style={{ originY: isPresent ? 0 : 1 }}
            className="transition-screen-step1"
          />
          <motion.div
            initial={{ scaleY: 1 }}
            animate={{ scaleY: 0, transition: { duration: 0.5, ease: "circOut", delay: 0.1 } }}
            exit={{ scaleY: 1, transition: { duration: 0.5, ease: "circIn", delay: 0.1 } }}
            style={{ originY: isPresent ? 0 : 1 }}
            className="transition-screen-step2"
          />
          {/* (e) 페이지 전환 애니메이션 */}
        </section>
      </div>
    </div>
  )
}